import React from 'react';
import { DocumentBibliothequeTemplate } from '../../Templates';
import { connect } from 'react-redux';
import {
  apiGetAllCategories,
  apiGetDocumentsById,
  apiGetDocumentLibrary
} from '../../Api/Documents/Documents';
class DocumentBibliotheque extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      types: [],
      data: [],
      empty: false,
      docList: [],
      docSections: [],
      file: {
        attachement: '',
        blob: '',
        url: ''
      }
    };
  }

  onReturn = () => {
    if (this.state.step === 1) {
      this.props.history.push('/Documents');
    } else {
      this.props.changeContainer({
        type: 'SET_CURRENT_PADDING',
        value: { padding: true }
      });
      this.setState({ step: 1, types: [] });
    }
  };

  onSelectType = (value) => {
    const list = [...this.state.types];
    const index = list.indexOf(value);
    if (index == -1) {
      if (this.state.types.length == 0) {
        list.push(value);
      }
    } else {
      list.splice(index, 1);
    }
    this.setState({ types: list });
  };

  onSubmit = () => {
    this.setState({
      step: 2
    });
    this.props.changeContainer({
      type: 'SET_CURRENT_PADDING',
      value: { padding: false }
    });
  };

  componentWillUnmount() {
    this.props.changeContainer({
      type: 'SET_CURRENT_PADDING',
      value: { padding: true }
    });
  }

  getAllCategories = async () => {
    const res = await apiGetAllCategories();
    res.data.forEach((element) => {
      if (element.categoryName === 'Garantie') {
        this.getDocumentList(element.id);
      }
    });
  };
  getAllDocuments = async () => {
    const res = await apiGetDocumentLibrary();
    let sections = res.data?.filter((item) => !item.parentDocumentLibraryId);
    sections = sections.map((category) => ({
      categoryName: category.name,
      categoryId: category.documentLibraryId,
      data: []
    }));

    let files = res.data?.filter((item) => item.parentDocumentLibraryId);
    files.forEach((item) => {
      const fileCategoryIndex = sections.findIndex((parentCategory) => {
        return parentCategory.categoryId === item.parentDocumentLibraryId;
      });
      if (fileCategoryIndex === -1) return;

      sections[fileCategoryIndex].data.push({
        filename: item.name,
        fileContentType: item.mimeType,
        content: item.fileUrl
      });
    });

    this.setState(
      res?.data?.length
        ? {
            docList: res.data.map((elem) => {
              return {
                name: `Garanties - ${elem.description}`,
                content: elem.fileContent
              };
            }),
            docSections: sections
          }
        : { empty: true }
    );
  };

  componentDidMount() {
    // this.getAllCategories();
    this.getAllDocuments();
  }

  getDocumentList = async (id) => {
    const res = await apiGetDocumentsById(id);
    if (res.status === 200) {
      this.setState({
        docList: res.data
      });
    } else {
      this.setState({
        docList: []
      });
    }
  };

  onDowLoad = async (el) => {
    try {
      const response = await fetch(el.content);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      this.setState({
        file: {
          attachement: el,
          blob,
          url: `${url}`
        }
      });
      if (url) {
        const download = document.createElement('a');
        download.setAttribute('href', url);
        download.setAttribute('target', '_blank');
        download.click();
      }
    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
  };

  onOpen = async (el) => {
    this.setState({
      documentSelected: el,
      step: 2,
      file: {
        attachement: el,
        url: `${el.content}`
      }
    });
  };

  createBlob = async (data) => {
    try {
      const blob = await (
        await fetch(`data:application/pdf;base64,${data}`)
      ).blob();
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (err) {}
  };

  render() {
    return (
      <DocumentBibliothequeTemplate
        name={'Ma bibliothèque'}
        state={this.state}
        history={this.props.history}
        onSelectType={this.onSelectType}
        onReturn={this.onReturn}
        onSubmit={this.onSubmit}
        onOpen={this.onOpen}
        onDowLoad={this.onDowLoad}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeContainer: (action) => {
      dispatch(action);
    }
  };
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  container: state.container
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentBibliotheque);
